import * as angular from 'angular';
import CoreModule from './../core/core.module';
import LoginService from './login.service';
import loginComponent from './login.component';
import loginRoutes from './login.routes';

export default angular
  .module('FHL.login', [
    CoreModule,
  ])
  .config((RouterServiceProvider) => {
    RouterServiceProvider.configureStates(loginRoutes);
  })
  .service('LoginService', LoginService)
  .component('login', loginComponent)
  .name;



// WEBPACK FOOTER //
// ./src/app/login/login.module.js